import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const CPDashboardCoachMetricsWrapper = styled.div`
  box-shadow: 0px 4px 30px 0px ${COLORS.shadow_black_2};
  background: ${COLORS.cirrus_white};
  border-radius: 8px 8px 0px 0px;
  padding: 24px 16px;

  ${responsive.MOBILE`
    padding: 16px 8px;
  `}

  .coach-metrics-info {
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      display: none;
    } // hide scrollbar
    gap: 24px;
    margin-top: 24px;

    ${responsive.MOBILE`
      flex-direction: column;
    `}
  }

  .coach-metrics-info-top {
    display: flex;
    justify-content: space-between;

    ${responsive.MOBILE`
      gap: 16px;
      flex-wrap: wrap;
      width: 100%;
    `}
  }

  .range-type-select {
    width: 200px;
    margin-right: 16px;

    ${responsive.MOBILE`
      width: 100%;
      margin-right: 0;
    `}
  }

  .title-icon {
    height: 36px;
    width: 36px;
    margin-right: 12px;
  }

  .d-none {
    display: none;
  }
`;
